import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import {
  NotificationService,
  NOTIFICATION_DURATIONS,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_SUCCESS,
} from 'ui-components/services/notification-service';

import { restoreFulfillmentsSuccess } from '../../store/orders/orders.actions';

import messages from './messages';

const restoreShipmentNotification = (title, content, notificationType) => {
  NotificationService.showNotification({
    notificationType,
    title: <FormattedMessage {...title} />,
    content: <FormattedMessage {...content} />,
    duration: NOTIFICATION_DURATIONS.SHORT,
  });
};

export const RestoreDropdownMenuItem = ({ isDisabled, apiCall }) => {
  const dispatch = useDispatch();

  const restoreShippedShipment = useCallback(() => {
    apiCall()
      .then(() => {
        restoreShipmentNotification(
          messages.restoreShipmentSuccessTitle,
          messages.restoreShipmentSuccessMessage,
          NOTIFICATION_TYPE_SUCCESS,
        );
        dispatch(restoreFulfillmentsSuccess());
      })
      .catch(() => {
        restoreShipmentNotification(messages.restoreShipmentErrorTitle, messages.restoreShipmentErrorMessage, NOTIFICATION_TYPE_ERROR);
      });
  }, [apiCall, dispatch]);

  return (
    <DropdownMenuItem disabled={isDisabled} onClick={restoreShippedShipment}>
      <FormattedMessage {...messages.restoreShipment} />
    </DropdownMenuItem>
  );
};

RestoreDropdownMenuItem.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  apiCall: PropTypes.func.isRequired,
};
